
// This source is part of the Akeria  and is
// copyrighted by Uniphore system software limited.

// All rights reserved.  No part of this work may be reproduced, stored in a
// retrieval system, adopted or transmitted in any form or by any means,
// electronic, mechanical, photographic, graphic, optic recording or otherwise,
// translated in any language or computer language, without the prior written
// permission of  Uniphore system software limited.

// Uniphore system software limited.
// Vaishnavi Silicon Terrace, B- Block, 
// 3rd & 4th floor, Hosur Rd, 
// Adugodi, Bengaluru, Karnataka 560095

// India

// Copyright 2019 Uniphore system software limited.

// Modification History

// Date            Version          Author                            Description
// ----------     -----------      ---------------                   ----------------------------------------
// 15 11 2019      1                Pappuraj                           Bank form Developed
// 26 11 2019      1.1              Pappuraj                           Bank form Developed
// 30 11 2019      1.2              Pappuraj                           Bug fixed
//09-01-2020              Adhrish choudhary              mandatory prrof added 


import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ActionSheetController } from '@ionic/angular';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { Base64 } from '@ionic-native/base64/ngx';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { IfscValidator } from 'src/app/validation/ifsc.validator';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
declare var window: any;

@Component({
    selector: 'app-bankform',
    templateUrl: './bankform.component.html',
    styleUrls: ['./bankform.component.scss'],
})
export class BankformComponent implements OnInit {
    public bankform: FormGroup;
    languageConext: any;
    headerTitle: any;
    percentage: any = 0;
    currentpath;
    bankTypes: any;
    selectedBanktype: any;
    confirmLabels: any;
    selectedconfirm: any;
    formsubmitted: boolean = false;
    passwordmismatch: boolean = false;
    imagePickerOptions = {
        maximumImagesCount: 1,
        quality: 50
    };
    saveBankDetails = "Yes";

    imgUrl: any;
    file1: any = {};
    file2: any = {};
    file3: any = {};
    file4: any = {};
    file5: any = {};
    fileArray: any = [];
    agreecheck: boolean = false;
    ownername: any;
    bankname: any;
    branchname: any;
    bankAccountNo: any;
    reBankAccountNo: any;
    ifsccode: any;
    TrustFrontImgFile: any;
    TrustBackImgFile: any;
    FrontImgFile: any;
    BackImgFile: any;
    FronImgName: any;
    BackImgName: any;
    FileSelected: any;
    Filearray: any;
    selproof: any;
    micrcode: any
    agreecheckaadhaaar: boolean = false;
    imageUpload: boolean = false;
    uploadDetails: any;
    displaySubmit: boolean = false;
    bankfullData: any;
    constructor(public formBuilder: FormBuilder,
        private router: Router,
        public navctrl: NavController,
        public platform: Platform,
        public cmndeclaration: CommonDeclarationService,
        public cmndef: CommonDefinitionService,
        private camera: Camera,
        public actionSheetController: ActionSheetController,
        private file: File,
        public api: RestapiService,
        private filePath: FilePath,
        private fileChooser: FileChooser,
        private base64: Base64,
        public actionVal: ActionlistenService,
        public _DomSanitizer: DomSanitizer,
        public iosfilepicker: IOSFilePicker,
        public statusBar: StatusBar) {
        this.imgUrl = "assets/images/profile_img.png";
        this.currentpath = this.router.url;
        this.cmndeclaration.closeBankImg.subscribe(data => {
            this.imageUpload = false;
            this.displaySubmit = false;
            this.cmndeclaration.Actionsheetenable = false;
        })
        if (localStorage.getItem('language') == 'en') {
            this.bankTypes = [
                {
                    "label": "Savings",
                    "value": "Savings",
                },
                {
                    "label": "Current",
                    "value": "Current",
                },
                {
                    "label": "NRE*",
                    "value": "NRE",
                },
                {
                    "label": "NRO",
                    "value": "NRO",
                }
            ]
            this.selectedBanktype = "Savings";
            this.confirmLabels = [
                {
                    "label": "Yes",
                    "value": "Yes",
                },
                {
                    "label": "No",
                    "value": "No",
                },

            ];
            this.selectedconfirm = "Yes";
        }
        else {
            this.bankTypes = [
                {
                    "label": "बचत",
                    "value": "Savings",
                },
                {
                    "label": "चालू",
                    "value": "Current",
                },
                {
                    "label": "एन आर ई*",
                    "value": "NRE",
                },
                {
                    "label": "एन आर ओ",
                    "value": "NRO",
                }
            ]
            this.selectedBanktype = "Savings";

            this.confirmLabels = [
                {
                    "label": "हाँ",
                    "value": "Yes",
                },
                {
                    "label": "नहीं",
                    "value": "No",
                }

            ];
            this.selectedconfirm = "Yes";

        }

        if (this.cmndeclaration.LanguageJson) {
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].bankform;
            console.log("a", this.languageConext.ownername);
        }
        else {
            this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].bankform;
            console.log("b", this.languageConext);
        }

        this.headerTitle = this.languageConext.heading.text;
        this.bankform = formBuilder.group({
            ownername: ['', Validators.required],
            bankname: ['', Validators.required],
            branchname: ['', Validators.required],
            bankAccountNo: ['', Validators.required],
            reBankAccountNo: ['', Validators.required],
            selproof: ['', Validators.required],
            ifsccode: new FormControl('', Validators.compose([
                IfscValidator.validIfsc
            ])),

            micrcode: [''],
            agreecheckaadhaar: [],
            agreecheck: [],
        });
    }
    ngOnInit() {

    }

    imgs() {

        this.FronImgName = "";
        this.FrontImgFile = "";
        this.BackImgFile = "";
        this.BackImgName = "";
        this.agreecheckaadhaaar = false;
        this.agreecheck = false;
        this.file2 = {};
        this.file3 = {};
        if (this.selproof == "Aadhaar") {
            this.TrustFrontImgFile = 'assets/images/aadhaar.png';
            this.TrustBackImgFile = 'assets/images/aadhaar.png';
        }
        else if (this.selproof == "Voter Id") {
            this.TrustFrontImgFile = 'assets/images/voter-id-card.png';
            this.TrustBackImgFile = 'assets/images/voterback.png';
        }
        else if (this.selproof == "Driving License") {
            this.TrustFrontImgFile = 'assets/images/drive.png';
            this.TrustBackImgFile = 'assets/images/driveback.png';
        }
        else if (this.selproof == "PAN Card") {
            this.TrustFrontImgFile = 'assets/images/panuploadIcon.PNG';
        }
        else
            if (this.selproof == "Passport") {
                this.TrustFrontImgFile = 'assets/images/passportfront.jfif';
                this.TrustBackImgFile = 'assets/images/passportback.jpg';
            }
            else
                if (this.selproof == "NREGA Job Card") {
                    this.TrustFrontImgFile = 'assets/images/naregasample.png';
                    this.TrustBackImgFile = 'assets/images/naregasample1.png';
                }
                else {
                    this.TrustFrontImgFile = 'assets/images/other.png';
                }
    }

    async recentUpload(flg: any) {
        this.pickImage(this.camera.PictureSourceType.CAMERA, flg)
    }


    pickImage(sourceType, flg) {
        let cameradir: any;
        let date = new Date();
        if (flg == 'recentphoto')
            cameradir = this.camera.Direction.FRONT
        else
            cameradir = this.camera.Direction.BACK
        const options: CameraOptions = {
            quality: localStorage.imagequality,
            sourceType: sourceType,
            destinationType: this.camera.DestinationType.DATA_URL,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE,
            cameraDirection: cameradir
        }
        this.camera.getPicture(options).then(async (imageData) => {
            if (this.platform.is('ios')) {
                await this.statusBar.overlaysWebView(true);
                await this.statusBar.overlaysWebView(false);
            }
            let base64Image = 'data:image/jpeg;base64,' + imageData;
            let stringLength: number = Number(imageData.length);
            let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
            let sizeInMB = sizeInBytes / 1000000;
            if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
                if (imageData.indexOf("file:/") != -1) {
                    this.base64.encodeFile(imageData).then((base64File: string) => {
                        if (flg == "recentphoto") {
                            this.file1.fileContent = base64File;
                            this.file1.fileContentName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);;
                        }
                        else if (flg == "idfront") {

                            this.FronImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
                            this.FrontImgFile = base64File;
                            this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                            this.file2.fileContent = base64File;
                            this.file2.fileContentName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);;
                        }
                        else if (flg == "idback") {

                            this.BackImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
                            this.BackImgFile = base64File;
                            this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                            this.file3.fileContent = base64File;
                            this.file3.fileContentName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);;
                        }
                        else if (flg == "cancelcheck") {
                            this.file4.fileContent = base64File;
                            this.file4.fileContentName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);;
                        }
                        else if (flg == "bankstmt") {
                            this.file5.fileContent = base64File;
                            this.file5.fileContentName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);;
                        }
                    });
                } else {
                    if (flg == "recentphoto") {
                        this.file1.fileContentName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.file1.fileContent = base64Image;
                    }
                    else if (flg == "idfront") {
                        this.FronImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.FrontImgFile = base64Image;
                        this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64Image);
                        this.file2.fileContentName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.file2.fileContent = base64Image;
                    }
                    else if (flg == "idback") {
                        this.BackImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.BackImgFile = base64Image;
                        this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64Image);
                        this.file3.fileContentName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.file3.fileContent = base64Image;
                    }
                    else if (flg == "cancelcheck") {
                        this.file4.fileContentName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.file4.fileContent = base64Image;
                    }
                    else if (flg == "bankstmt") {
                        this.file5.fileContentName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
                            this.file5.fileContent = base64Image;
                    }
                }
            } else
                this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
        }, async (err) => {
            if (this.platform.is('ios')) {
                await this.statusBar.overlaysWebView(true);
                await this.statusBar.overlaysWebView(false);
            }
        });
    }

    async uploadFile(flg: any) {
        this.cmndeclaration.Actionsheetenable = true;
        const actionSheet = await this.actionSheetController.create({
            header: "Select Image source",
            buttons: [{
                text: 'Load from Library',
                handler: () => {
                    this.cmndeclaration.Actionsheetenable = false;
                    if (this.cmndeclaration.runPlatform == 'ios')
                        this.IOSFileselect(flg);
                    else
                        this.Fileselect(flg);
                }
            },
            {
                text: 'Use Camera',
                handler: () => {
                    this.cmndeclaration.Actionsheetenable = false;
                    this.pickImage(this.camera.PictureSourceType.CAMERA, flg);
                }
            },
            {
                text: 'Cancel',
                role: 'cancel',
                handler: () => {
                    this.cmndeclaration.Actionsheetenable = false;
                }
            }
            ]
        });
        await actionSheet.present();
    }

    Fileselect(flg) {
        let validFormate: any;
        let stringLength: any;
        if (this.platform.is('android')) {
            this.fileChooser.open()
                .then(
                    uri => {
                        this.filePath.resolveNativePath(uri)
                            .then(url => {
                                var fileName = url.substring(url.lastIndexOf("/") + 1);

                                validFormate = url.substring(url.lastIndexOf("."), url.length);
                                console.log(validFormate);
                                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                                    this.base64.encodeFile(url).then((base64File: string) => {
                                        if (validFormate.toLowerCase() == ".pdf") {
                                            stringLength = base64File.indexOf("64,") + 3;
                                            base64File = "data:application/pdf;base64," + base64File.substring(stringLength, base64File.length);
                                            stringLength = base64File.length - 'data:application/pdf;base64,'.length;
                                        } else
                                            stringLength = base64File.length - 'data:image/png;base64,'.length;
                                        let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                                        let sizeInMB = sizeInBytes / 1000000;
                                        if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                                            if (flg == "recentphoto") {
                                                this.file1.fileContent = base64File;
                                                this.file1.fileContentName = fileName;
                                            }
                                            else if (flg == "idfront") {
                                                this.FronImgName = fileName;
                                                if (validFormate.toLowerCase() == ".pdf") {
                                                    this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                                                }

                                                else {
                                                    this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                                                    this.FrontImgFile = base64File;
                                                }

                                                this.file2.fileContent = base64File;
                                                this.file2.fileContentName = fileName;
                                            }
                                            else if (flg == "idback" && (this.selproof == 'Driving License' || this.selproof == 'Aadhaar' || this.selproof == 'Voter Id' || this.selproof == 'Passport' || this.selproof == 'NREGA Job Card')) {
                                                this.BackImgName = fileName;
                                                if (validFormate.toLowerCase() == ".pdf") {
                                                    this.TrustBackImgFile = "assets/images/pdfimg.PNG"
                                                }

                                                else {
                                                    this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                                                    this.BackImgFile = base64File;
                                                }
                                                this.file3.fileContent = base64File;
                                                this.file3.fileContentName = fileName;
                                            }
                                            else if (flg == "cancelcheck") {
                                                this.file4.fileContent = base64File;
                                                this.file4.fileContentName = fileName;
                                            }
                                            else if (flg == "bankstmt") {
                                                this.file5.fileContent = base64File;
                                                this.file5.fileContentName = fileName;
                                            }
                                        } else {
                                            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                                        }
                                    });
                                } else {
                                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
                                }

                            })
                            .catch(err => console.log(err));
                    }
                )
                .catch(error => {
                    console.log(error)
                });
        }
    }

    async IOSFileselect(flg) {
        let filePath: any;
        let fileName: any;
        let path: any;
        let validFormate: any;
        let stringLength: any;
        await this.iosfilepicker.pickFile().then(async uri => {
            filePath = "file://" + uri;
            fileName = filePath.split('/').pop();
            path = filePath.substring(0, filePath.lastIndexOf("/") + 1);
            this.file.readAsDataURL(path, fileName).then(base64File => {
                sessionStorage.demo = base64File;
                validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);
                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                    stringLength = base64File.substring(base64File.indexOf("64,") + 3, base64File.length);
                    stringLength = stringLength.length;
                    console.log(stringLength);
                    let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                    let sizeInMB = sizeInBytes / 1000000;
                    if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                        if (flg == "recentphoto") {
                            this.file1.fileContent = base64File;
                            this.file1.fileContentName = fileName;
                        }
                        else if (flg == "idfront") {
                            this.FronImgName = fileName;
                            if (validFormate.toLowerCase() == ".pdf") {
                                this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                            }

                            else {
                                this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                                this.FrontImgFile = base64File;
                            }

                            this.file2.fileContent = base64File;
                            this.file2.fileContentName = fileName;
                        }
                        else if (flg == "idback" && (this.selproof == 'Driving License' || this.selproof == 'Aadhaar' || this.selproof == 'Voter Id' || this.selproof == 'Passport' || this.selproof == 'NREGA Job Card')) {
                            this.BackImgName = fileName;
                            if (validFormate.toLowerCase() == ".pdf") {
                                this.TrustBackImgFile = "assets/images/pdfimg.PNG"
                            }

                            else {
                                this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                                this.BackImgFile = base64File;
                            }
                            this.file3.fileContent = base64File;
                            this.file3.fileContentName = fileName;
                        }
                        else if (flg == "cancelcheck") {
                            this.file4.fileContent = base64File;
                            this.file4.fileContentName = fileName;
                        }
                        else if (flg == "bankstmt") {
                            this.file5.fileContent = base64File;
                            this.file5.fileContentName = fileName;
                        }
                    } else
                        this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");
                } else
                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid");
            })
                .catch(() => {
                    console.log('Error reading file');
                })
        })
            .catch(err => console.log('Error', err));
    }



    async changebankType(selected) {
        this.selectedBanktype = selected;
    }

    changeconfirmLabel(selected) {
        this.selectedconfirm = selected;
    }

    async bankUpdate() {
        this.uploadDetails = [];
        this.fileArray = [];
        if (this.bankform.valid &&
            (((this.selproof == "Aadhaar") && this.agreecheck == false && this.agreecheckaadhaaar == true && (this.file1.fileContentName && this.file2.fileContentName &&
                this.file3.fileContentName && (this.file4.fileContentName || this.file5.fileContentName))) ||
                ((this.selproof != "Aadhaar") && this.agreecheck == true && this.agreecheckaadhaaar == false && (this.file1.fileContentName && this.file2.fileContentName &&
                    (((this.selproof == 'Driving License' || this.selproof == 'Voter Id' || this.selproof == 'Passport' || this.selproof == 'NREGA Job Card') && this.file3.fileContentName) || (this.selproof == 'PAN Card' && !this.file3.fileContentName)) && (this.file4.fileContentName || this.file5.fileContentName))))) {

            if (!this.file4.fileContentName) {
                this.file4 = {};
            }
            if (!this.file5.fileContentName) {
                this.file5 = {};
            }
            if (!this.file3.fileContentName) {
                this.file3 = {};
            }
            if (this.file1.fileContentName) {
                this.fileArray.push(this.file1);
                this.uploadDetails.push({ "title": this.languageConext.uploadmsg.img1, "img": "assets/images/icn_error.png" })
            } if (this.file2.fileContentName) {
                this.fileArray.push(this.file2);
                this.uploadDetails.push({ "title": this.languageConext.uploadmsg.img2, "img": "assets/images/icn_error.png" })
            } if (this.file3.fileContentName) {
                this.fileArray.push(this.file3);
                this.uploadDetails.push({ "title": this.languageConext.uploadmsg.img3, "img": "assets/images/icn_error.png" })
            } if (this.file4.fileContentName) {
                this.fileArray.push(this.file4);
                this.uploadDetails.push({ "title": this.languageConext.uploadmsg.img4, "img": "assets/images/icn_error.png" })
            } if (this.file5.fileContentName) {
                this.fileArray.push(this.file5);
                this.uploadDetails.push({ "title": this.languageConext.uploadmsg.img5, "img": "assets/images/icn_error.png" })
            }
            let params = {
                "policyOwnerName": this.bankform.value.ownername,
                "bankName": this.bankform.value.bankname,
                "bankBranchName": this.bankform.value.branchname,
                "bankAccountNo": this.bankform.value.bankAccountNo,
                "bankIfscCode": this.bankform.value.ifsccode,
                "bankAccountType": this.selectedBanktype,
                "MicrCode": this.bankform.value.micrcode,
                "actionVal": null,
                "FuturePolicyPayout": this.saveBankDetails
            }

            let data: any = {};
            data.userSessionID = localStorage.userSessionID,
            data.userChatSessionID = localStorage.userChatSessionId ? localStorage.userChatSessionId : "";
            data.actionType = localStorage.getItem('bankformtype');
            data.actionVal = JSON.stringify(params);
            this.bankfullData = data;
            this.uploadImages();
        }
    }

    retypeaccno(ev) {
        console.log(ev.detail.value)
        console.log(ev.detail.value.length)
        if (ev.detail.value.length == 0) {
            this.passwordmismatch = false;
        }
        else {
            this.passwordmismatch = true
        }
    }
    getFileContentAsBase64(path, callback) {
        window.resolveLocalFileSystemURL(path, gotFile, fail);

        function fail(e) {
            alert('Cannot found requested file');
        }
        function gotFile(fileEntry) {
            fileEntry.file(function (file) {
                var reader = new FileReader();
                reader.onloadend = function (e) {
                    var content = this.result;
                    callback(content);
                };
                // The most important point, use the readAsDatURL Method from the file plugin
                reader.readAsDataURL(file);
            });
        }
    }

    termscont() {
        console.log(this.agreecheck)
    }

    termscontaadhar() {
        console.log(this.agreecheckaadhaaar)
    }

    validatefun(event: any, flg: any) {

        if (flg == 'ownername') {
            this.ownername = this.ownername.replace(/[^a-zA-Z ]+/g, '');
        }
        else if (flg == 'bankname') {
            this.bankname = this.bankname.replace(/[^a-zA-Z ]+/g, '');
        }
        else if (flg == 'branchname') {
            this.branchname = this.branchname.replace(/[^a-zA-Z ]+/g, '');
        }
        else if (flg == 'bankAccountNo') {
            this.bankAccountNo = this.bankAccountNo.replace(/[^0-9]/g, '');
        }
        else if (flg == 'reBankAccountNo') {
            this.reBankAccountNo = this.reBankAccountNo.replace(/[^0-9]/g, '');
        }
        else if (flg == 'ifsccode') {
            this.ifsccode = this.ifsccode.replace(/[^A-Za-z0-9]/g, '');
        }

    }


    changeListener($event, flg): void {
        let name: any;
        let validFormate: any;
        let imgname: any;
        let sizeInBytes: any;
        let stringLength: any;
        let sizeInMB: any;
        name = $event.target.files[0].name;
        this.FileSelected = flg;
        validFormate = name.substring(name.lastIndexOf("."), name.length);
        if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
            this.cmndef.readThis($event.target).then(data => {
                imgname = data;
                stringLength = imgname.length - imgname.indexOf("64,") + 3;
                sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                sizeInMB = sizeInBytes / 1000000;
                console.log(sizeInMB);
                if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                    if (flg == "recentphoto") {
                        this.file1.fileContent = imgname;
                        this.file1.fileContentName = name;
                    }
                    else if (flg == "idfront") {
                        this.FronImgName = name;
                        if (validFormate.toLowerCase() == ".pdf") {
                            this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                        } else {
                            this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(imgname);
                            this.FrontImgFile = imgname;
                        }

                        this.file2.fileContent = imgname;
                        this.file2.fileContentName = name;
                    }
                    else if (flg == "idback" && (this.selproof == 'Driving License' || this.selproof == 'Aadhaar' || this.selproof == 'Voter Id' || this.selproof == 'Passport' || this.selproof == 'NREGA Job Card')) {
                        this.BackImgName = name;
                        if (validFormate.toLowerCase() == ".pdf") {
                            this.TrustBackImgFile = "assets/images/pdfimg.PNG"
                        }

                        else {
                            this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(imgname);
                            this.BackImgFile = imgname;
                        }
                        this.file3.fileContent = imgname;
                        this.file3.fileContentName = name;
                    }
                    else if (flg == "cancelcheck") {
                        this.file4.fileContent = imgname;
                        this.file4.fileContentName = name;
                    }
                    else if (flg == "bankstmt") {
                        this.file5.fileContent = imgname;
                        this.file5.fileContentName = name;
                    }
                } else {
                    this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                }
            })
        } else {
            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
        }
    }

    validateText() {
        this.micrcode = this.micrcode.replace(/[^A-Za-z0-9!@#$%^&*()-+_.,'"]/g, '');
    }

    async uploadImages() {
        this.imageUpload = true;
        this.cmndeclaration.Actionsheetenable = true;
        this.percentage = 0;
        let sumVal = 0;
        if (this.fileArray.length == 3)
            sumVal = 33.33
        else if (this.fileArray.length == 4)
            sumVal = 25;
        else if (this.fileArray.length == 5)
            sumVal = 20;

        this.pushImages(0, sumVal);
    }

    async pushImages(idx, prctInc) {
        let req: any;
        if (idx < this.fileArray.length && this.imageUpload) {
            if (this.fileArray[idx].fileContent != undefined && this.fileArray[idx].fileContent != "") {
                req = {
                    "userSessionID": localStorage.userSessionID,
                    "userChatSessionID": localStorage.userChatSessionId,
                    "FileName": this.fileArray[idx].fileContentName,
                    "FileContent": this.fileArray[idx].fileContent,
                    "FileNo": (idx + 1)
                }
                if (this.cmndeclaration.Networkstatus) {
                    await this.api.postapi("uploadImage", req).then(async (data: any) => {
                        console.log(data);
                        this.uploadDetails[idx].img = "assets/images/checked.png";
                        this.percentage = this.percentage + prctInc;
                        if (idx == this.fileArray.length - 1)
                            this.percentage = 100;
                        if (document.getElementById("bar") != null && this.percentage > 12) {
                            document.getElementById("bar").style.width = this.percentage + "%";
                        }
                        if (idx + 1 < this.fileArray.length)
                            this.pushImages(idx + 1, prctInc);
                        else
                            this.displaySubmit = true;
                    }, (err: any) => {
                        this.displaySubmit = false;
                        this.imageUpload = false;
                        this.cmndeclaration.Actionsheetenable = false;
                        if(err.sorry != undefined && err.sorry == "no response")
                            this.cmndef.presentAlert(this.languageConext.uploadmsg.label, this.languageConext.uploadmsg.lblmsg, "Image upload")
                        else
                            this.cmndef.Showtoast(this.cmndeclaration.LanguageJson.pages[0].alerts.unablenetwork);
                    });
                } else {
                    this.imageUpload = false;
                    this.cmndeclaration.Actionsheetenable = false;
                    this.cmndef.Showtoast(this.cmndeclaration.LanguageJson.pages[0].alerts.unablenetwork);
                }
            }
        }
    }

    public async banksubmit() {
        console.log(this.bankfullData);
        this.imageUpload = false;
        this.cmndeclaration.Actionsheetenable = false;
        this.cmndef.loaderstart();
        this.api.clickenventcap("submit_" + this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
        await this.api.postapi("akeiraVAAction", this.bankfullData).then(async data => {
            this.cmndef.loaderend();
            let res = data;
            this.cmndef.loaderend();
            this.cmndeclaration.TamlismaJson = res["chatResp"][0];
            this.displaySubmit = false;
            sessionStorage.CurrentPage = "/va/chat";
            this.navctrl.navigateForward("/va/chat");
        }, err => {
            console.log(err);
            this.displaySubmit = false;
            this.cmndef.loaderend();
        });
    }

    closepop(){
        this.imageUpload = false;
        this.displaySubmit = false;
        this.cmndeclaration.Actionsheetenable = false;
    }

}